import { createTheme } from "@mui/material";

export const theme = createTheme({
  typography: {
    fontFamily: "Sora",
  },
  palette: {
    primary: { main: "#0b1c12" },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "inherit",
          fontWeight: 700,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "#000",
        },
      },
    },
  },
});
